import classes from './EmergencyButton.module.css';
import { useState } from 'react';

// IMPORT FONTAWESOME ICONS
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCarBurst } from '@fortawesome/free-solid-svg-icons';
import { useBrandFind } from '../../hooks/useFinders';
import { useParams } from 'react-router-dom';

function EmergencyButton() {
  const params = useParams();
  const brand = params.brand;
  const [expanded, setExpanded] = useState(false);
  const brandHouse = useBrandFind(brand, 'house');
  let style = null;
  if (expanded) style = { width: 'calc(100% - 64px)', opacity: 1 };
  else style = null;
  function expansionHandler() {
    setExpanded(!expanded);
  }
  return (
    <div
      className={`${classes.emergencyButton} ${expanded && classes.active}`}
      style={style}
    >
      <span
        className={`${classes.emergencyInfo} ${expanded && classes.active}`}
        onClick={() => {
          window.location.href = 'tel:+' + brandHouse.NOTFALL_LINK;
        }}
      >
        Tel.: {brandHouse.NOTFALL}
      </span>
      <span onClick={expansionHandler}>
        <FontAwesomeIcon icon={faCarBurst} />
      </span>
    </div>
  );
}

export default EmergencyButton;
